"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');

var FindButtons = function (_React$Component) {
    _inherits(FindButtons, _React$Component);

    function FindButtons() {
        _classCallCheck(this, FindButtons);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    FindButtons.prototype.render = function render() {
        return React.createElement(
            "div",
            { className: "inner-container buttons" },
            React.createElement("input", { id: "find-directions-button-" + this.props.id, type: "button", className: "btn btn-default directions-button", value: "Get Directions" }),
            React.createElement("input", { id: "find-select-button-" + this.props.id, type: "button", className: "btn btn-default select-button", value: "Select" }),
            React.createElement("div", { className: "clear" })
        );
    };

    return FindButtons;
}(React.Component);

var OrderButtons = function (_React$Component2) {
    _inherits(OrderButtons, _React$Component2);

    function OrderButtons() {
        _classCallCheck(this, OrderButtons);

        return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }

    OrderButtons.prototype.render = function render() {
        return React.createElement(
            "div",
            { className: "inner-container buttons" },
            React.createElement("input", { id: "find-order-button-" + this.props.id, type: "button", className: "btn btn-default order-button", value: "Order Here", onClick: this.props.orderButtonClick })
        );
    };

    return OrderButtons;
}(React.Component);

var NotifyButtons = function (_React$Component3) {
    _inherits(NotifyButtons, _React$Component3);

    function NotifyButtons() {
        _classCallCheck(this, NotifyButtons);

        return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
    }

    NotifyButtons.prototype.render = function render() {
        return React.createElement(
            "div",
            { className: "inner-container buttons" },
            React.createElement("input", { id: "find-order-button-" + this.props.id, type: "button", className: "btn btn-default order-button", value: "Notify Me When I Can Order Here", onClick: this.props.notifyClick })
        );
    };

    return NotifyButtons;
}(React.Component);

module.exports = function (_React$Component4) {
    _inherits(_class2, _React$Component4);

    function _class2() {
        var _temp, _this4, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this4 = _possibleConstructorReturn(this, _React$Component4.call.apply(_React$Component4, [this].concat(args))), _this4), _this4.orderButtonClick = function () {
            if (_this4.props.orderButtonClick) {
                _this4.props.orderButtonClick(_this4.props.location);
            }
        }, _this4.notifyClick = function () {
            if (_this4.props.notifyClick) {
                _this4.props.notifyClick(_this4.props.id);
            }
        }, _this4.roundSafely = function (distance) {
            var ret = distance;
            try {
                if (!isNaN(distance)) ret = Math.round(distance * 100) / 100;
            } catch (err) {}

            return ret;
        }, _this4.testFunc = function () {
            console.log('test func');
        }, _this4.toggleFavorite = function () {
            //TODO: check if user is logged in , cookie?
            if (_this4.props.toggleFavorite) {
                _this4.props.toggleFavorite(_this4.props.id);
            }
        }, _temp), _possibleConstructorReturn(_this4, _ret);
    }

    _class2.prototype.render = function render() {
        var location = this.props.location;
        var buttons = React.createElement(FindButtons, { id: this.props.id, location: this.props.location });
        var favoriteToggle = '';

        if (this.props.buttonType == "ordering") {
            if (location.hasMobileOrder) {
                buttons = React.createElement(OrderButtons, { id: this.props.id, orderButtonClick: this.orderButtonClick });
            } else {
                buttons = React.createElement(NotifyButtons, { id: this.props.id, notifyClick: this.notifyClick });
            }
        } else {
            favoriteToggle = React.createElement(
                "div",
                { onClick: this.toggleFavorite, className: "favorite-button" },
                React.createElement(
                    "div",
                    { className: this.props.isFavorite ? 'glyph-button favorite' : 'favorite' },
                    React.createElement("span", { id: "find-favorite-" + this.props.id, className: "glyphicon glyphicon-heart" })
                )
            );
        }

        return React.createElement(
            "div",
            { className: "search-result-container" },
            React.createElement(
                "div",
                { className: "inner-container with-float" },
                React.createElement(
                    "div",
                    { id: "find-distance-" + this.props.id, className: "distance" },
                    this.roundSafely(location.distance),
                    " mi"
                ),
                React.createElement(
                    "div",
                    { id: "find-description-" + this.props.id, className: "info" },
                    React.createElement(
                        "h2",
                        { onClick: this.testFunc },
                        location.title
                    ),
                    React.createElement(
                        "p",
                        null,
                        location.address1
                    ),
                    React.createElement(
                        "p",
                        null,
                        location.address2
                    ),
                    React.createElement(
                        "p",
                        null,
                        "Phone: ",
                        location.phone
                    ),
                    React.createElement(
                        "p",
                        null,
                        "Today's Hours: ",
                        location.hours
                    )
                ),
                favoriteToggle,
                React.createElement("div", { className: "clear" })
            ),
            React.createElement(
                "div",
                { className: "inner-container" },
                React.createElement(
                    "ul",
                    { id: "find-offerings-" + this.props.id, className: "offerings" },
                    React.createElement("li", null),
                    React.createElement("li", null),
                    React.createElement("li", null),
                    React.createElement("li", null),
                    React.createElement("li", null),
                    React.createElement("li", null),
                    React.createElement("li", null)
                )
            ),
            React.createElement(
                "div",
                { ref: "mini_map", className: "inner-container mini-map" },
                React.createElement("img", { src: "https://maps.googleapis.com/maps/api/staticmap?center=" + location.location.lat + "," + location.location.lon + "&markers=color:red|" + location.location.lat + "," + location.location.lon + "&zoom=11&size=300x75" })
            ),
            buttons,
            React.createElement("div", { className: "separator" })
        );
    };

    return _class2;
}(React.Component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/mapComponents/SearchResult.js
// module id = 825
// module chunks = 0